import {PropertyHouseType} from "../../../offer/detail/constants/PropertyHouseType";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseType: ISearchFilterSlot<"house_type", string[]> = {
    id: "house_type",
    label: "Typ domu",
    filters: [
        {
            id: "house_type",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "houses_type_semi_detached", value: PropertyHouseType.SEMI_DETACHED.toString(), label: "Bliźniak"},
                {id: "houses_type_serial", value: PropertyHouseType.SERIAL.toString(), label: "Szeregowy"},
                {id: "houses_type_detached", value: PropertyHouseType.DETACHED.toString(), label: "Wolnostojący"},
                {id: "houses_type_wooden", value: PropertyHouseType.WOODEN.toString(), label: "Z bali"}
            ]
        }
    ]
};
import {PropertyHouseType} from "../../../offer/detail/constants/PropertyHouseType";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseType: ISearchFilterSlot<"house_type", string[]> = {
    id: "house_type",
    label: "Typ domu",
    filters: [
        {
            id: "house_type",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "houses_type_semi_detached", value: PropertyHouseType.SEMI_DETACHED.toString(), label: "Bliźniak"},
                {id: "houses_type_serial", value: PropertyHouseType.SERIAL.toString(), label: "Szeregowy"},
                {id: "houses_type_detached", value: PropertyHouseType.DETACHED.toString(), label: "Wolnostojący"},
                {id: "houses_type_wooden", value: PropertyHouseType.WOODEN.toString(), label: "Z bali"}
            ]
        }
    ]
};
